module.exports = __webpack_public_path__ + "fonts/NittiGrotesk-Regular.eot";